import { Api, } from "@/services/configs/axios";
import { AxiosPromise } from "axios";



export class ComentariosService {
  postComentarios = (plano_id: any, params: any): AxiosPromise<any> => Api.post(`comentarios/${plano_id}`, params);
  getComentarios = (plano_id: any, params?: any): AxiosPromise<any> => Api.get(`comentarios/plano/${plano_id}`, {params: params});
}